import {faker} from "@faker-js/faker";
import Alert from "@mui/material/Alert";

export default function ReportedPoll({isMyPolls}) {
  const isReported = faker.datatype.boolean({
    probability: 0.5
  })
  const violationType = faker.helpers.arrayElement(['Duplicate content', 'Copyright content', 'Sex/Nudity'])
  const isMyPollReported = isMyPolls && isReported === true
  return <>{isMyPollReported &&
    <Alert severity={"error"}>{violationType}. This poll is only visible to you. </Alert>}</>
}
